import { USER_ROLE } from "../constants/user";

export const isAdmin = (role: any): boolean => {
  return role.includes(USER_ROLE.ADMIN);
};
